import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/sharp-regular-svg-icons";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";

export function PreviewSurveyButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Button onClick={() => void navigate({ to: ".", search: { preview: true } })}>
            <FontAwesomeIcon icon={faEye} className="pr-1" /> {t("common.preview")}
        </Button>
    );
}
